import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Clock2 = function Clock2(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 42.37 42.37",
    children: [/*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      d: "M21.19,0A21.19,21.19,0,1,0,42.37,21.19,21.21,21.21,0,0,0,21.19,0Zm1.5,39.29V36.06a1.5,1.5,0,0,0-3,0v3.23A18.17,18.17,0,0,1,3.08,22.69H6.31a1.5,1.5,0,0,0,0-3H3.08A18.17,18.17,0,0,1,19.69,3.08V6.31a1.5,1.5,0,0,0,3,0V3.08A18.19,18.19,0,0,1,39.3,19.69H36.06a1.5,1.5,0,0,0,0,3H39.3A18.19,18.19,0,0,1,22.69,39.29Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      d: "M22.67,20.56V12.9a1.5,1.5,0,1,0-3,0v8.28a1.5,1.5,0,0,0,.44,1.06l4.35,4.35a1.47,1.47,0,0,0,1.06.44,1.45,1.45,0,0,0,1.06-.44,1.49,1.49,0,0,0,0-2.12Z"
    })]
  });
};
export default Clock2;